import { styled } from "styled-components";

import { knowledgeApiSlice } from "api/knowledgeApi.slice";
import { SectionTitleUnderlined, SeeAllButton, StyledGrid, Tile } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";

const StyledContainer = styled.div`
  margin-bottom: 2rem;
`;

export const VideosResults = () => {
  const translate = useTranslate();

  const currentSearchQuery = useSelector((state) => state.search.currentSearchQuery);
  const currentSources = useSelector((state) => state.search.sources);

  const { data: paginatedVideos, isFetching } = knowledgeApiSlice.endpoints.searchVideos.useInfiniteQuery({
    searchQuery: currentSearchQuery,
    sourceNames: currentSources.map((source) => source.name),
  });

  const videos = paginatedVideos?.pages.flat() ?? [];

  if (currentSearchQuery.length === 0 || videos.length === 0) return null;

  return (
    <>
      <StyledContainer>
        <SectionTitleUnderlined
          isLoading={isFetching}
          id="videos"
          rightElement={<SeeAllButton link="/search/videos" />}
        >
          {translate("app.discover.topic.tabs.videos.title")}
        </SectionTitleUnderlined>
        <StyledGrid numberOfItems={[1, 2, 3, 4, 5]}>
          {videos.slice(0, 4).map((video) => (
            <Tile
              key={video.id}
              title={video.title}
              subtitle={video.source?.name}
              link={`/search/videos/${video.id}`}
              image={video.images?.thumbnail}
            />
          ))}
        </StyledGrid>
      </StyledContainer>
    </>
  );
};
